/**
 * @file Phone authentication modal.
 */

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import compose from 'lodash.flowright';

import withModal from '../global/modal/withModal';
import { PHONE_AUTH_MODAL } from '../../constants/modals';
import PhoneAuthWithEmailFallback from './PhoneAuthWithEmailFallback';

class PhoneAuthModalContent extends Component {
  static propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    actionProps: PropTypes.shape({
      onLogin: PropTypes.func,
      resetStoreAfterLogin: PropTypes.bool,
      introText: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.string,
      ]),
      secondaryRedirectRoute: PropTypes.string,
    }),
    client: PropTypes.shape({
      resetStore: PropTypes.func.isRequired,
    }),
    enableEmailFallback: PropTypes.bool,
  };

  static defaultProps = {
    actionProps: {},
    enableEmailFallback: true,
  };

  onLogin = async (...args) => {
    const {
      onRequestClose,
      actionProps: { onLogin },
    } = this.props;

    if (onLogin) {
      await onLogin(...args);
    }

    onRequestClose();
  };

  render() {
    const {
      client,
      actionProps: {
        secondaryRedirectRoute,
        introText,
        submitText,
        resetStoreAfterLogin,
      },
      enableEmailFallback,
    } = this.props;

    return (
      <Fragment>
        <PhoneAuthWithEmailFallback
          emailVerificationRedirectUrl={secondaryRedirectRoute}
          onAuthSuccess={(...args) => {
            this.onLogin(...args);

            if (resetStoreAfterLogin) {
              client.resetStore();
            }
          }}
          introText={
            introText ||
            'Verify your mobile number to sign in. Waldo will text a verification code to the number below.'
          }
          submitText={submitText}
          defaultEmailStep="LOGIN"
          enableEmailFallback={enableEmailFallback}
        />
      </Fragment>
    );
  }
}

export default withModal(compose(withApollo)(PhoneAuthModalContent), {
  name: PHONE_AUTH_MODAL,
  contentLabel: 'Sign In',
  size: 'sm',
  overlayClassName: 'z-modal-max',
});
